type Guid = string;

export type DeepLinkCorrelationIdType = Guid;

export const deepLinkTargetTypes = [
  'admin',
  'event',
  'group',
  'home',
  'thread',
  'topic',
  'user',
  'officeuserstorylinepublisher',
  'storyline',
  'leaderdashboard',
  'leadershipcorner',
  'question',
  'questionspage',
  'userachievement',
  'campaign',
  'askmeanything',
  'digest',
  'userstoryline',
  'newfollowers',
  'suggestedconnections',
  'creatorimpact',
] as const;
export type DeepLinkTargetType = (typeof deepLinkTargetTypes)[number];

export type DeepLinkType = 'ntfn' | 'custom' | 'copiedlink' | 'crossapp';

export const deepLinkTypes: DeepLinkType[] = ['ntfn', 'custom', 'copiedlink', 'crossapp'];

export const deepLinkSubTypes = [
  'userMention',
  'announcementCreated',
  'userAddedToCommunity',
  'directFollower',
  'userSharedStory',
  'storylineDigest',
  'reaction',
  'userReply',
  'newTeamsQnAOrganizerReply',
  'newTeamsQnAQuestionPosted',
  'yourTeamsQnAQuestionApproved',
  'teamsQnAQuestionPendingApproval',
  'teamsQnAEnabledForMeeting',
  'userQuestionApproved',
  'newTeamsQnADiscussionPosted',
  'newTeamsQnAPrivateReply',
  'newTeamsQnAOrganizerPrivateReply',
  'newAnswerInYourQuestion',
  'newAnswerInFollowedQuestion',
  'yourAnswerMarkedBest',
  'bestAnswerOnFollowedQuestion',
  'bestAnswerReminder',
  'voteOnYourQuestion',
  'yourAnswerVoted',
  'leadershipAnnouncement',
  'campaignLiveAnnouncement',
  'userAchievement',
  'userMentionInQuestion',
  'questionsForMeDigest',
  'reactionToYourMessage',
  'reminderToMarkBest',
  'newQuestionInAskMeAnything',
  'newReplyInAskMeAnythingQuestion',
  'organizerUpcomingAskMeAnything',
  'newReplyInYourVotedAMAQuestion',
  'newAnonymousQuestionInAMA',
  'anonymousUserMentionInAMA',
  'subscribedTopicNewThreadStarter',
  'subscribedTopicAddedToThread',
  'groupExpertMemberRoleAdded',
  'newReactionInCommunity',
  'newReplyInCommunity',
  'newReplyInMessage',
  'newReactionInMessage',
  'yourAnswerMarkedVerified',
  'verifiedAnswerOnFollowedQuestion',
  'newAnswerInQuestion',
  'bestOrVerifiedAnswerMarked',
  'subscribedTopicNewPost',
  'subscribedTopicAddedToPost',
  'communityAgentReviewRequest',
  'newAnonymousReplyInTeamsQnA',
  'newAnonymousReplyInAMA',
  'groupExpertMemberRoleRequested',
  'delegateFlagPostForLeader',
  'newPostInAMA',
  'newPostInTeamsQnA',
  'communityAgentPaused',
  'weeklyDigest',
  'emptyStorylineAddContentAttempt1',
  'emptyStorylineAddContentAttempt2',
  'emptyStorylineAddContentAttempt3',
  'storylineNewFollowers',
  'gotSuggestedConnections',
  'newAgentAnswerInYourQuestion',
  'newAgentAnswerInFollowedQuestion',
  'newAgentReplyInMessage',
  'communityExpert',
  'newCreatorImpactReport',
  'communityAgentReviewDraftedAnswer',
] as const;
export type DeepLinkSubType = (typeof deepLinkSubTypes)[number];

export interface DeepLinkDetails {
  readonly entityId: string;
  readonly entityType: DeepLinkTargetType;
  readonly correlationId?: DeepLinkCorrelationIdType;
  readonly subType?: DeepLinkSubType;
  readonly type: DeepLinkType;
  readonly notificationType?: string;
}

export interface CrossAppDeepLinkDetails {
  /**
   * Type of the deep link
   */
  readonly deepLinkType: 'crossapp';
  /**
   * Path of the target page, excluding the /teams or /main prefix
   */
  readonly path?: string;
  /**
   * Query parameters of the target page. It may also include parameters for telemetry purposes.
   */
  readonly params?: Record<string, string>;
  /**
   * Scenario type of the target page
   */
  readonly targetType?: DeepLinkTargetType;
  /**
   * EntityId of the target page
   */
  readonly targetInstance?: string;
}

export type AppLaunchInitiator = 'left_rail' | 'activity_bar' | 'universal_create_button' | 'chat_tab';
